const TimetableModel = (json, lang) => {
    let data = [];
    
    json.map((res) => {
        if (res.score) {
            let item = {
                global: false,
                name: ``,
                periode: false,
                message: "",
                is_24_7: res.timetable.is_24_7,
                periode_list: [
                    {
                        message: false,
                        periodeFrom: "",
                        periodeMessage: "",
                        periodeUntil: "",
                    },
                ],
                show_exceptions: false,
                exceptions: [],
                table: {
                    monday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    tuesday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    wednesday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    thursday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    friday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    saturday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    sunday: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                    global: [{ closed: false, afwijkend: false, from: "", until: "", messageText: "" }],
                },
            };

            // Set timetable type
            item.name = res.timetable.timetable_type[`title_${lang}`] || res.timetable.timetable_type.title;
            item.id = res.timetable.id;
            item.timetabletype_id = res.timetable?.timetable_type?.timetabletype_id

            // Fill in records
            if (res.timetable.messages.length > 0) { 
                item.message = res.timetable.messages[0].message;
            }
            if (res.timetable.day_exception.length > 0) { 
                item.show_exceptions = true;
            }

            if (res.timetable.period.length === 1) {
                item.periode_list[0].periodeFrom = res.timetable.period[0].start || "";
                item.periode_list[0].periodeUntil = res.timetable.period[0].end || "";
                item.periode_list[0].periodeMessage = res.timetable.period[0].reason || "";
                item.periode_list[0].message = !!res.timetable.period[0].reason;
            } else if (res.timetable.period.length > 1) {
                item.periode_list = res.timetable.period.map((per) => ({
                    periodeFrom: per.start || "",
                    periodeUntil: per.end || "",
                    periodeMessage: per.reason || "",
                    message: !!per.reason
                }));
            }
            if (item.periode_list.length > 0 && item.periode_list[0].periodeFrom !== "") { 
                item.periode = true;
            }

            // Handle exceptions
            res.timetable.day_exception.forEach((exception, i) => {
                let slots = exception.exception_timeslots.map(slot => ({
                    from: slot.from_time,
                    until: slot.to_time,
                    messageText: slot.message?.message || null
                }));

                if (slots.length === 0) {
                    slots.push({ from: "", until: "", messageText: null });
                }

                item.exceptions.push({
                    date: exception.date,
                    other: !!exception.date,
                    holliday: exception.holliday,
                    message: exception.message,
                    closed: exception.closed,
                    is_recurring: exception.is_recurring || false,
                    slots: slots,
                });
            });

            // Function to add timeslots or mark as closed
            const addTimeslots = (dayArray, timeslots, isClosed) => {
                if (isClosed) {
                    dayArray[0] = { closed: true, afwijkend: false, from: "", until: "", messageText: "" };
                    return;
                }
                timeslots.forEach((slot) => {
                    if (dayArray.length === 1 && dayArray[0].from === "" && dayArray[0].until === "") {
                        dayArray[0] = {
                            closed: false,
                            afwijkend: true,
                            from: slot.from_time,
                            until: slot.to_time,
                            messageText: slot.message?.message || "",
                        };
                    } else {
                        dayArray.push({
                            closed: false,
                            afwijkend: true,
                            from: slot.from_time,
                            until: slot.to_time,
                            messageText: slot.message?.message || "",
                        });
                    }
                });
            };

            // Assign time slots to each day while respecting the "closed" status
            res.timetable.records.forEach((record) => {
                if (record.valid_days.includes("1")) addTimeslots(item.table.monday, record.timeslots, record.closed);
                if (record.valid_days.includes("2")) addTimeslots(item.table.tuesday, record.timeslots, record.closed);
                if (record.valid_days.includes("3")) addTimeslots(item.table.wednesday, record.timeslots, record.closed);
                if (record.valid_days.includes("4")) addTimeslots(item.table.thursday, record.timeslots, record.closed);
                if (record.valid_days.includes("5")) addTimeslots(item.table.friday, record.timeslots, record.closed);
                if (record.valid_days.includes("6")) addTimeslots(item.table.saturday, record.timeslots, record.closed);
                if (record.valid_days.includes("7")) addTimeslots(item.table.sunday, record.timeslots, record.closed);
                if (record.valid_days.includes("0")) {
                    item.global = true;
                    addTimeslots(item.table.global, record.timeslots, record.closed);
                }
            });

            data.push(item);
        } else {
            data.push(res);
        }
    });

    return data;
};

export default TimetableModel;
